<div class="mb-address-book-wrapper">
  <div class="row no-gutters mt-3  text-left mb-checkout-headline">
    {{ 'mbMyAccount.mbMyAddressbook.headerShippingAddresses' | cxTranslate }}
  </div>
  <div class="row" data-cy="mb-address-book-list">
    <ng-container *ngIf="(shippingAddresses$ | async) as shipAddresses">
      <ng-container *ngIf="shipAddresses.length > 0; else emptyShippingAddress" >
        <div *ngFor="let address of shipAddresses" class="col-12 col-md-6">
          <mb-address-tile [address]="address"
                           [formRegion]="checkoutRegion"
                           [isSelectedAddress]="false"
                           [showSelectionRadiobox]="false"
          >
          </mb-address-tile>
        </div>
      </ng-container>
      <ng-template #emptyShippingAddress>
        <div class="text-center col-12 col-md-6">
          <mb-empty-address-tile
            [headline]="'mbMyAccount.mbMyAddressbook.emptyAddress.headline' | cxTranslate"
            [message]="'mbMyAccount.mbMyAddressbook.emptyAddress.messageShipping' | cxTranslate"
            [link]="'/'"
            [linkText]="'mbMyAccount.mbMyAddressbook.emptyAddress.linkText' | cxTranslate">
          </mb-empty-address-tile>
        </div>
      </ng-template>
    </ng-container>
  </div>
  <div class="row no-gutters mt-3 text-left mb-checkout-headline">
    {{ 'mbMyAccount.mbMyAddressbook.headerBillingAddresses' | cxTranslate }}
  </div>
  <div class="row" data-cy="mb-address-book-list">
    <ng-container *ngIf="(billingAddresses$ | async) as billAddresses">
      <ng-container *ngIf="billAddresses.length > 0; else emptyBillingAddress" >
        <div *ngFor="let address of billAddresses" class="col-12 col-md-6">
          <mb-address-tile [address]="address"
                           [formRegion]="checkoutRegion"
                           [isSelectedAddress]="false"
                           [showSelectionRadiobox]="false"
          >
          </mb-address-tile>
        </div>
      </ng-container>
      <ng-template #emptyBillingAddress>
        <div class="text-center col-12 col-md-6">
          <mb-empty-address-tile
            [headline]="'mbMyAccount.mbMyAddressbook.emptyAddress.headline' | cxTranslate"
            [message]="'mbMyAccount.mbMyAddressbook.emptyAddress.messageBilling' | cxTranslate"
            [link]="'/'"
            [linkText]="'mbMyAccount.mbMyAddressbook.emptyAddress.linkText' | cxTranslate">
          </mb-empty-address-tile>
        </div>
      </ng-template>
    </ng-container>
  </div>
  <mb-myaccount-button
    [path]="'myAccount'"
    [textTranslationPath]="'mbMyAccount.backToMyAccount'"
  ></mb-myaccount-button>
</div>
<mb-myaccount-mobile-navigation></mb-myaccount-mobile-navigation>
